import { Theme } from '@material-ui/core';
import { Box, Grid, styled, Typography } from '@mui/material';

export const Body = styled(Grid)(() => ({
  padding: '1rem 5rem',
  marginTop: '70px',
  gap: '1rem',
  justifyContent: 'space-between',
  alignItems: 'flex-end',
  position: 'relative',
}));

export const Section = styled(Grid)(() => ({
  display: 'flex',
  justifyContent: 'start',
  flexDirection: 'column',
}));

export const LightBg = styled(Box)(() => ({
  backgroundColor: '#312F41',
  // padding: '1rem',
  borderRadius: '20px',
  height: '100%',
  maxHeight: '80vh',
}));

export const SearchInputCont = styled(Grid)(() => ({
  padding: '1rem 0rem',
  flexGrow: '0',
  maxHeight: 'fit-content',
  flexBasis: '50px !important',
}));

export const StoryAvatarCont = styled(Grid)(() => ({
  padding: '1rem 0rem',
  gap: '0rem 1rem',
  display: 'flex',
  flexWrap: 'nowrap',
  overflowX: 'auto',
  minHeight: '150px',
}));

export const TitleText = styled(Typography)(() => ({
  fontSize: '1.2rem',
  color: '#fff',
}));

export const ParaText = styled(Typography)(() => ({
  fontSize: '1rem',
  color: '#fff',
  margin: '0px',
}));

export const DHeader = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '1rem 1.5rem 1rem 1.5rem',
  borderBottom: '1px solid #565463',
  position: 'relative',
}));

export const HeaderAvatarCont = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  '& .text__cont': {
    marginLeft: '.5rem',
  },
}));

export const TabsWrapper = styled(Box, {
  shouldForwardProp: prop => prop !== 'noBackground',
})<{ noBackground?: boolean; theme?: Theme }>(({ theme, noBackground }) => ({
  backgroundColor: 'rgba(255,255,255,0.1)',
  padding: '5px',
  borderRadius: '15px',
  width: noBackground ? '80%' : '100%',
  boxSizing: 'border-box',
  marginBottom: noBackground ? '30px' : '0px',
}));

export const MessageCont = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
}));
